import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    heading: `"Inter", sans-serif`,  
    body: `"Inter", sans-serif`, 
  },
  styles: {
    global: {
      "input[type='radio']": {
        borderColor: "#797979",
        _hover: {
          backgroundColor: "transparent !important", 
          borderColor: "#797979 !important",
        },
        _focus: {
          boxShadow: "none !important", 
        },
      },
    },
  },
  components: {
    Radio: {
      baseStyle: {
        control: {
          borderColor: "#797979",
          _hover: {
            backgroundColor: "transparent",
            borderColor: "#797979",
          },
          _checked: {
            backgroundColor: "#797979",
            borderColor: "#797979",
          },
          _focusVisible: {
            boxShadow: "none",
          },
        },
      },
    },
  },
});

export default theme;
